import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TermsAndConditions } from '../models/terms-and-conditions.model';
import { BaseHttpService } from '../../shared/services/base-http.service';
import { Observable } from 'rxjs';
import { UserConsent } from '../models/user-consent.model';
import { ConsentServiceType } from '../models/consent-service-type.model';

@Injectable({ providedIn: 'root' })
export class TermsAndConditionsService extends BaseHttpService<TermsAndConditions> {

  constructor(
    private http: HttpClient
  ) {
    super(http);
    this.apiDomain = environment.identityApiUrl;
    this.endpoint = 'ConsentDefinitions';
  }

  checkAcceptance(userId: string, consent: ConsentServiceType): Observable<UserConsent> {
    const url = `${this.apiDomain}/api/UserConsents/Active/${userId}/${consent}`;
    return this.http.get<UserConsent>(url);
  }
}
